// src/functions/isListingOnSale.js

export default function isListingOnSale(data) {
  let isOffer = false;
  const now = new Date();

  if (data?.listing_sale_price && data?.listing_stock_amount !== 0) {
    if (data.listing_sale_startDate && data.listing_sale_endDate) {
      // Start and end date exist
      isOffer = new Date(data.listing_sale_startDate) <= now && new Date(data.listing_sale_endDate) >= now;
    } else if (!data.listing_sale_startDate && data.listing_sale_endDate) {
      // Only end date exists
      isOffer = new Date(data.listing_sale_endDate) >= now;
    } else if (data.listing_sale_startDate && !data.listing_sale_endDate) {
      // Only start date exists
      isOffer = new Date(data.listing_sale_startDate) <= now;
    } else {
      // No start or end date, listing is always on sale
      isOffer = true;
    }
  }

  return isOffer;
}
